import { ApiResponse } from 'apisauce';
import { RobocloudError } from '~/types/common';

interface ErrorPayload {
  error: string;
  code?: string;
  subCode?: string;
  showSnackbar: boolean;
}

/**
 * Formats received api response to be compatible with user message reducer expected payload.
 * Expects:
 * - ApiErrorResponse when response ended in failure
 * - ApiOkResponse when response didn't end in failure, but payload is still invalid
 */
export const formatApiErrorPayload = <T, U = T>(response: ApiResponse<T, U>): ErrorPayload => {
  const errorData = (response.data as RobocloudError)?.error;
  return {
    error: (response.problem as string) || 'UNKNOWN_ERROR',
    code: errorData?.code,
    subCode: errorData?.subCode,
    showSnackbar: response.status !== 403,
  };
};
